import { render } from "./upload.vue?vue&type=template&id=29e79c8c&ts=true"
import script from "./upload.vue?vue&type=script&lang=tsx"
export * from "./upload.vue?vue&type=script&lang=tsx"

import "./upload.vue?vue&type=style&index=0&id=29e79c8c&lang=less"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__